"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseDualList = require("nicbase-dual-list");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _yup = require("yup");

var _segmentDetailsModule = _interopRequireDefault(require("./segment-details.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var createProjectsDropdownOptions = function createProjectsDropdownOptions(projects) {
  return projects.sort(function (a, b) {
    return a.projectName > b.projectName ? 1 : -1;
  }).map(function (project) {
    return {
      label: project.projectName,
      value: project.id
    };
  });
};

var SegmentDetails = function SegmentDetails(_ref) {
  var _segments$selectedSeg;

  var projects = _ref.projects,
      alarms = _ref.alarms,
      segments = _ref.segments,
      selectedSegment = _ref.selectedSegment,
      onUpdate = _ref.onUpdate,
      onDelete = _ref.onDelete;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useUser = (0, _nicbaseReducers.useUser)(),
      email = _useUser.email;

  var _ref2 = (_segments$selectedSeg = segments[selectedSegment]) !== null && _segments$selectedSeg !== void 0 ? _segments$selectedSeg : {},
      _ref2$externalId = _ref2.externalId,
      externalId = _ref2$externalId === void 0 ? '' : _ref2$externalId,
      _ref2$alarms = _ref2.alarms,
      tourAlarms = _ref2$alarms === void 0 ? [] : _ref2$alarms,
      _ref2$emailRecipients = _ref2.emailRecipients,
      emailRecipients = _ref2$emailRecipients === void 0 ? [] : _ref2$emailRecipients,
      _ref2$smsRecipients = _ref2.smsRecipients,
      smsRecipients = _ref2$smsRecipients === void 0 ? [] : _ref2$smsRecipients,
      report = _ref2.report,
      _ref2$projects = _ref2.projects,
      tourProjects = _ref2$projects === void 0 ? [] : _ref2$projects;

  var _ref3 = report || {},
      _ref3$recipients = _ref3.recipients,
      recipients = _ref3$recipients === void 0 ? [] : _ref3$recipients,
      showGeoInformation = _ref3.showGeoInformation,
      _ref3$shareViaEmail = _ref3.shareViaEmail,
      shareViaEmail = _ref3$shareViaEmail === void 0 ? true : _ref3$shareViaEmail,
      _ref3$uploadAsIdocFor = _ref3.uploadAsIdocFormat,
      uploadAsIdocFormat = _ref3$uploadAsIdocFor === void 0 ? false : _ref3$uploadAsIdocFor;

  var onSegmentsUpdate = function onSegmentsUpdate(value) {
    var newSegments = [].concat(_toConsumableArray(segments.slice(0, selectedSegment)), [_objectSpread(_objectSpread({}, segments[selectedSegment]), value)], _toConsumableArray(segments.slice(selectedSegment + 1)));
    onUpdate({
      segments: newSegments
    });
  };

  var emailSchema = (0, _yup.string)().email();
  var phoneSchema = (0, _yup.number)().min(1);

  var _useState = (0, _react.useState)(emailRecipients.some(function (recipient) {
    return recipient.recipient === email;
  }) ? '' : email),
      _useState2 = _slicedToArray(_useState, 2),
      mailAddress = _useState2[0],
      setMailAddress = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      phoneNumber = _useState4[0],
      setPhoneNumber = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mailError = _useState6[0],
      setMailError = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      phoneError = _useState8[0],
      setPhoneError = _useState8[1];

  var onNewEmailRecipient = function onNewEmailRecipient() {
    try {
      if (emailSchema.validateSync(mailAddress)) {
        var newEmailRecipients = emailRecipients.slice(0);
        var filteredEmailRecipients = newEmailRecipients.filter(function (recipient) {
          return recipient.recipient !== mailAddress;
        }).concat({
          assignedAlarms: tourAlarms.length > 0,
          recipient: mailAddress
        });
        onSegmentsUpdate({
          emailRecipients: filteredEmailRecipients
        });
        setMailAddress('');
        setMailError(false);
      }
    } catch (e) {
      setMailError(true);
    }
  };

  var onDeleteEmailRecipient = function onDeleteEmailRecipient(name) {
    onSegmentsUpdate({
      emailRecipients: emailRecipients.filter(function (recipient) {
        return recipient.recipient !== name;
      })
    });
  };

  var onPhoneNumberChanged = function onPhoneNumberChanged(phoneInput) {
    var cleanedRecipient = phoneInput.replace(/[^0-9+]/g, '');
    setPhoneNumber(cleanedRecipient);
  };

  var onNewPhoneRecipient = function onNewPhoneRecipient() {
    try {
      if (phoneSchema.validateSync(phoneNumber)) {
        var newPhoneRecipients = smsRecipients.slice(0);
        newPhoneRecipients.push(_objectSpread(_objectSpread({}, {
          assignedAlarms: tourAlarms.length > 0
        }), {}, {
          recipient: phoneNumber
        }));
        onSegmentsUpdate({
          smsRecipients: newPhoneRecipients
        });
        setPhoneNumber('');
        setPhoneError(false);
      }
    } catch (e) {
      setPhoneError(true);
    }
  };

  var onDeletePhoneRecipient = function onDeletePhoneRecipient(name) {
    onSegmentsUpdate({
      smsRecipients: smsRecipients.filter(function (recipient) {
        return recipient.recipient !== name;
      })
    });
  }; // projects


  var projectsDropdownOptions = (0, _react.useMemo)(function () {
    return createProjectsDropdownOptions(projects);
  }, [projects]);

  var onProjectChange = function onProjectChange(id, index) {
    if (!tourProjects.some(function (tourProject) {
      return tourProject.id === id;
    })) {
      var _projects$find;

      var _ref4 = (_projects$find = projects.find(function (currentProject) {
        return currentProject.id === id;
      })) !== null && _projects$find !== void 0 ? _projects$find : {},
          tourProperties = _ref4.tourProperties,
          projectType = _ref4.projectType;

      var newProject = _objectSpread(_objectSpread({}, tourProjects[index]), {
        id: id,
        type: projectType,
        tourProperties: Object.fromEntries(Object.entries(tourProperties !== null && tourProperties !== void 0 ? tourProperties : {}).map(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 1),
              key = _ref6[0];

          return [key, ''];
        }))
      });

      onSegmentsUpdate({
        projects: [].concat(_toConsumableArray(tourProjects.slice(0, index)), [newProject], _toConsumableArray(tourProjects.slice(index + 1)))
      });
    }
  };

  var onInputChange = function onInputChange(index, key, value) {
    var project = _objectSpread(_objectSpread({}, tourProjects[index]), {}, {
      tourProperties: _objectSpread(_objectSpread({}, tourProjects[index].tourProjects), {}, _defineProperty({}, key, value))
    });

    var updatedProjects = tourProjects.slice(0);
    updatedProjects.splice(index, 1, project);
    onSegmentsUpdate({
      projects: updatedProjects
    });
  };

  var onAddClicked = function onAddClicked() {
    onSegmentsUpdate({
      projects: [].concat(_toConsumableArray(tourProjects), [{
        id: null,
        type: null,
        tourProperties: {}
      }])
    });
  };

  var onRemoveClicked = function onRemoveClicked(index) {
    var updatedProjects = tourProjects.slice(0);
    updatedProjects.splice(index, 1);
    onSegmentsUpdate({
      projects: updatedProjects
    });
  };

  var onSelectAlarms = function onSelectAlarms(selectedObjects) {
    try {
      var newEmailRecipients = emailRecipients.slice(0);
      var filteredEmailRecipients = newEmailRecipients.map(function (recipient) {
        return _objectSpread(_objectSpread({}, recipient), {}, {
          assignedAlarms: true
        });
      });

      if (emailSchema.validateSync(mailAddress)) {
        filteredEmailRecipients = mailAddress.length > 0 ? newEmailRecipients.filter(function (recipient) {
          return recipient.recipient !== mailAddress;
        }).concat({
          assignedAlarms: tourAlarms.length > 0,
          recipient: mailAddress
        }).map(function (recipient) {
          return _objectSpread(_objectSpread({}, recipient), {}, {
            assignedAlarms: true
          });
        }) : newEmailRecipients.map(function (recipient) {
          return _objectSpread(_objectSpread({}, recipient), {}, {
            assignedAlarms: true
          });
        });
        setMailAddress('');
        setMailError(false);
      }

      var newPhoneRecipients = smsRecipients.map(function (recipient) {
        return _objectSpread(_objectSpread({}, recipient), {}, {
          assignedAlarms: true
        });
      });
      onSegmentsUpdate({
        alarms: selectedObjects.map(function (object) {
          return object.id;
        }),
        emailRecipients: filteredEmailRecipients,
        smsRecipients: newPhoneRecipients
      });
    } catch (e) {
      setMailError(true);
    }
  };

  var onDeselectAlarms = function onDeselectAlarms(deselectedObjects) {
    var alarmsToDeselect = deselectedObjects.map(function (object) {
      return object.id;
    });
    var deselectedAlarms = tourAlarms.filter(function (tourAlarmId) {
      return !alarmsToDeselect.includes(tourAlarmId);
    });
    var newEmailRecipients = emailRecipients.map(function (recipient) {
      return _objectSpread(_objectSpread({}, recipient), {}, {
        assignedAlarms: deselectedAlarms.length > 0
      });
    });
    var newPhoneRecipients = smsRecipients.map(function (recipient) {
      return _objectSpread(_objectSpread({}, recipient), {}, {
        assignedAlarms: deselectedAlarms.length > 0
      });
    });
    onSegmentsUpdate({
      alarms: deselectedAlarms,
      emailRecipients: newEmailRecipients,
      smsRecipients: newPhoneRecipients
    });
  };

  var getSelectableAlarms = function getSelectableAlarms() {
    var selectableAlarms = alarms.filter(function (alarm) {
      return !tourAlarms.includes(alarm.id);
    });
    return selectableAlarms.map(function (alarm) {
      return {
        id: alarm.id,
        label: alarm.name
      };
    });
  };

  var getSelectedAlarms = function getSelectedAlarms() {
    return tourAlarms.map(function (tourAlarmId) {
      var selectedAlarm = alarms.find(function (alarm) {
        return alarm.id === tourAlarmId;
      }) || {};
      return {
        id: selectedAlarm.id,
        label: selectedAlarm.name
      };
    });
  };

  var onReportEnabledChanged = function onReportEnabledChanged(reportEnabled) {
    if (reportEnabled) {
      // if the report has been enabled, add the users email address
      onSegmentsUpdate({
        report: _objectSpread(_objectSpread({}, report), {}, {
          recipients: [email],
          showGeoInformation: true,
          shareViaEmail: true,
          uploadAsIdocFormat: false
        })
      });
    } else {
      // if the report has been disabled, delete all the emails
      onSegmentsUpdate({
        report: _objectSpread(_objectSpread({}, report), {}, {
          recipients: [],
          showGeoInformation: true,
          shareViaEmail: true,
          uploadAsIdocFormat: false
        })
      });
    }
  };

  var onShowGeoInformationChanged = function onShowGeoInformationChanged() {
    onSegmentsUpdate({
      report: _objectSpread(_objectSpread({}, report), {}, {
        showGeoInformation: !showGeoInformation
      })
    });
  };

  var onShareViaEmailChanged = function onShareViaEmailChanged() {
    onSegmentsUpdate({
      report: _objectSpread(_objectSpread({}, report), {}, {
        shareViaEmail: !shareViaEmail
      })
    });
  };

  var onUploadAsIdocFormatChanged = function onUploadAsIdocFormatChanged() {
    onSegmentsUpdate({
      report: _objectSpread(_objectSpread({}, report), {}, {
        uploadAsIdocFormat: !uploadAsIdocFormat
      })
    });
  };

  var _useState9 = (0, _react.useState)(''),
      _useState10 = _slicedToArray(_useState9, 2),
      reportRecipient = _useState10[0],
      setReportRecipient = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      reportRecipientError = _useState12[0],
      setReportRecipientError = _useState12[1];

  var onAddReportRecipientClicked = function onAddReportRecipientClicked() {
    var lowerCaseEmail = reportRecipient.toLowerCase();

    try {
      if (emailSchema.validateSync(lowerCaseEmail)) {
        var updatedReportRecipients = recipients // remove an already existing duplicate
        .filter(function (recipient) {
          return recipient !== lowerCaseEmail;
        }) // add the new object
        .concat(lowerCaseEmail);
        onSegmentsUpdate({
          report: _objectSpread(_objectSpread({}, report), {}, {
            recipients: updatedReportRecipients
          })
        });
        setReportRecipient('');
        setReportRecipientError(false);
      }
    } catch (e) {
      setReportRecipientError(true);
    }
  };

  var onDeleteEmailClicked = function onDeleteEmailClicked(recipient) {
    var updatedReportRecipients = recipients === null || recipients === void 0 ? void 0 : recipients.filter(function (rec) {
      return rec !== recipient;
    });
    onSegmentsUpdate({
      report: _objectSpread(_objectSpread({}, report), {}, {
        recipients: updatedReportRecipients
      })
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-12"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: "Segment ".concat(selectedSegment + 1)
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "w-64",
    value: externalId,
    onChange: function onChange(newValue) {
      return onSegmentsUpdate({
        externalId: newValue
      });
    },
    type: "text",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.road.createTour.externalId"
    }),
    max: true,
    Length: 64
  }), projects.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-64 mt-6"
  }, tourProjects.map(function (project, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _segmentDetailsModule["default"].container
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Dropdown, {
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.project"
      }),
      onChange: function onChange(id) {
        return onProjectChange(id, index);
      },
      source: projectsDropdownOptions,
      value: Number(project.id),
      className: "w-96"
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: _segmentDetailsModule["default"].removeProject,
      onClick: function onClick() {
        return onRemoveClicked(index);
      }
    })), project.tourProperties ? Object.entries(project.tourProperties).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-indent
        _react["default"].createElement(_nicbaseForms.Input, {
          value: value,
          label: key,
          onChange: function onChange(inputValue) {
            return onInputChange(index, key, inputValue);
          }
        })
      );
    }) : null);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "add-text-primary inline-flex items-center cursor-pointer font-bold pb-8",
    onClick: onAddClicked
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "inline-block fill-primary mr-2 cursor-pointer"
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.addProject"
  })))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.alarms"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDualList.DualListControlled, {
    selectableItems: getSelectableAlarms(),
    selectedItems: getSelectedAlarms(),
    onSelect: onSelectAlarms,
    onSelectAll: onSelectAlarms,
    onDeselect: onDeselectAlarms,
    onDeselectAll: onDeselectAlarms
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col ml-2 mt-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.notification"
    })
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "mr-1",
    error: mailError && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.emailIsNotValid"
    }),
    place: "top",
    value: mailAddress,
    label: intl.formatMessage({
      id: 'common.email'
    }),
    onChange: function onChange(newValue) {
      setMailError(false);
      setMailAddress(newValue);
    },
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'common.ok'
    }),
    onClick: onNewEmailRecipient
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "h-4 w-4 inline-block cursor-pointer"
  }))), emailRecipients.map(function (rec) {
    var recipient = rec.recipient;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "my-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-baseline"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-48"
    }, recipient), /*#__PURE__*/_react["default"].createElement("span", {
      title: intl.formatMessage({
        id: 'common.delete'
      }),
      onClick: function onClick() {
        return onDeleteEmailRecipient(recipient);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: "h-4 w-4 inline-block cursor-pointer fill-primary"
    }))));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col ml-2 mt-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "mr-1",
    error: phoneError && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.smsIsNotValid"
    }),
    place: "top",
    value: phoneNumber,
    label: intl.formatMessage({
      id: 'common.sms'
    }),
    onChange: function onChange(newValue) {
      setPhoneError(false);
      onPhoneNumberChanged(newValue);
    },
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'common.ok'
    }),
    onClick: onNewPhoneRecipient
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "h-4 w-4 inline-block cursor-pointer"
  }))), smsRecipients.map(function (rec) {
    var recipient = rec.recipient;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "my-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-baseline"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-48"
    }, recipient), /*#__PURE__*/_react["default"].createElement("span", {
      title: intl.formatMessage({
        id: 'common.delete'
      }),
      onClick: function onClick() {
        return onDeletePhoneRecipient(recipient);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: "h-4 w-4 inline-block cursor-pointer fill-primary"
    }))));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-192"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "my-4",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.enableSegmentReport"
    }),
    checked: !shareViaEmail || recipients.length > 0,
    onChange: onReportEnabledChanged
  }), !shareViaEmail || recipients.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.segmentReportMessage"
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourReportPositionMessage"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.withoutPositionInformation"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: showGeoInformation,
    onChange: onShowGeoInformationChanged
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.withPositionInformation"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.uploadReport"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: shareViaEmail,
    onChange: onShareViaEmailChanged
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.emailReport"
  }))), !shareViaEmail ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-2 ml-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.Idoc"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: uploadAsIdocFormat,
    onChange: onUploadAsIdocFormatChanged
  }))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "mr-2 w-72",
    value: reportRecipient,
    label: intl.formatMessage({
      id: 'common.email'
    }),
    error: reportRecipientError && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.emailIsNotValid"
    }),
    onChange: function onChange(newValue) {
      setReportRecipientError(false);
      setReportRecipient(newValue);
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "cursor-pointer h-5 w-5",
    onClick: onAddReportRecipientClicked
  })), recipients.map(function (recipient) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center mb-2"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-72 mr-2 truncate"
    }, recipient), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: "fill-primary cursor-pointer h-5 w-5",
      onClick: function onClick() {
        return onDeleteEmailClicked(recipient);
      }
    }));
  })) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6 flex items-center cursor-pointer",
    onClick: function onClick() {
      return onDelete(selectedSegment);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
    className: "fill-primary mr-2"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold text-primary text-base"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.deleteSegment"
  })))));
};

SegmentDetails.propTypes = {
  projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    projectName: _propTypes["default"].string,
    endpointId: _propTypes["default"].number,
    sharedData: _propTypes["default"].arrayOf(_propTypes["default"].string)
  })),
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  segments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    validityWayPointIndexRange: _propTypes["default"].arrayOf(_propTypes["default"].number),
    projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    alarms: _propTypes["default"].arrayOf(_propTypes["default"].number),
    externalId: _propTypes["default"].string,
    emailRecipients: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
    smsRecipients: _propTypes["default"].arrayOf(_propTypes["default"].shape())
  })),
  selectedSegment: _propTypes["default"].number,
  onUpdate: _propTypes["default"].func,
  onDelete: _propTypes["default"].func
};

var noop = function noop() {};

SegmentDetails.defaultProps = {
  projects: [],
  segments: [],
  selectedSegment: null,
  onUpdate: noop,
  onDelete: noop
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.road'])(SegmentDetails);

exports["default"] = _default;